import { useMutation } from '@tanstack/react-query';
import { uploadOrderToReturnPhoto } from '../services';

const useUploadOrderToReturnPhoto = () => {
  return useMutation({
    mutationKey: ['uploadOrderToReturnPhoto'],
    mutationFn: async (payload) => await uploadOrderToReturnPhoto(payload),
    retry: 3,
  });
};

export default useUploadOrderToReturnPhoto;
